// @flow
import * as React from 'react';
import SearchView from 'containers/search';
import { AnswerFieldsets } from './SearchForm';

export default class AnswerSearch extends React.PureComponent<*> {
  static label = 'Answers';

  render() {
    return (
      <SearchView
        label={AnswerSearch.label}
        primaryFieldsets={AnswerFieldsets.primaryFieldsets}
        extraFieldsets={AnswerFieldsets.extraFieldsets}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/search/Answers.js